import * as Yup from "yup";

export const vendorSchema = Yup.object().shape({
  vendor_name: Yup.string().required("Required"),
  tag_name: Yup.string().required("Required"),
});
